import { svg } from "./svgStyles";

export const checkboxSmall = {
  ".checkbox": {
    background: "white",
    border: "1px solid",
    borderColor: "grey5",
    borderRadius: "2px",
    width: "30px",
    height: "30px",
    position: "relative",
  },

  ".label": {
    cursor: "inherit",
    fontFamily: "body",
    fontWeight: "light",
    fontSize: "20px",
    letterSpacing: "0.025em",
    ml: "10px",
  },
};

export const checkboxMedium = {
  ".checkbox": {
    background: "white",
    border: "1px solid",
    borderColor: "grey5",
    borderRadius: "2px",
    width: "40px",
    height: "40px",
    position: "relative",
  },

  ".label": {
    cursor: "inherit",
    fontFamily: "body",
    fontWeight: "light",
    fontSize: "30px",
    letterSpacing: "0.025em",
    ml: "10px",
  },
};

export const checkboxBase = {
  cursor: "pointer",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",

  input: {
    cursor: "inherit",
    height: "1px",
    width: "1px",
    position: "absolute",
    left: "0",
    opacity: "0.01",
  },

  "input + svg": {
    cursor: "inherit",
    display: "none",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    ...svg("black"),
  },

  "input:checked + svg": {
    display: "block",
  },

  "&:hover .checkbox": {
    borderColor: "primary",

    svg: {
      ...svg("primary"),
    },
  },

  "&[disabled], &:disabled": {
    cursor: "not-allowed",

    ".label": {
      color: "grey7",
    },

    ".checkbox": {
      background: "grey9",
      borderColor: "grey7",
      color: "grey7",

      svg: {
        ...svg("grey7"),
      },
    },
  },
};
